import isEmpty from 'lodash/isEmpty';


export const getPlace = (place)=>
{
    if(!isEmpty(place)) {
        switch (place.type) {
            case 'step':
                return place.step.title
            case 'locality':
                return place.step.title + " - " + place.locality?.title
            case 'stop':
                return place.stop.title + " - " + place.step.title + ' - ' + place.locality?.title
        }
        return place.stop?.title + " - " + place.step?.title + ' - ' + place.locality?.title
    }
    return '';
}